import type { Copy } from "../types";

export const it: Copy = {
    seo: {
      title: "Calcolatore età veicolo | verifica per anno e mese",
      description:
        "Controlla l'età esatta di un veicolo dall'anno di produzione e dal mese opzionale. Vedi anni, mesi, giorni, giorni totali e tappe in un unico strumento.",
      keywords: [
        "calcolatore età veicolo",
        "età auto",
        "età veicolo per anno",
        "anno di produzione auto",
        "mese di produzione veicolo",
        "quanti anni ha la mia auto",
        "controllo età veicolo",
        "calcolatore età RC",
        "calcolatore data veicolo",
        "età auto per mese",
        "alternativa mParivahan",
        "alternativa Parivahan",
        "calcolatore età veicolo RTO",
        "controllo età immatricolazione auto",
        "età immatricolazione veicolo",
      ],
      faq: [
        {
          question: "Cosa fa questo calcolatore?",
          answer:
            "Calcola l'età esatta di un veicolo dall'anno di produzione scelto e dal mese opzionale, mostrando anni, mesi, giorni e tappe.",
        },
        {
          question: "Perché c'è un mese opzionale?",
          answer:
            "Il mese rende il calcolo più preciso. Se lo salti, l'app usa gennaio dell'anno selezionato.",
        },
        {
          question: "Posso scegliere un anno o un mese futuro?",
          answer:
            "No. Gli anni futuri sono bloccati e i mesi futuri vengono disattivati quando l'anno selezionato è quello corrente.",
        },
      ],
    },
    headerTagline: "Utilità veicoli",
    headerTitle: "Calcolatore età veicolo",
    reset: "Reimposta",
    switchToLight: "Passa al tema chiaro",
    switchToDark: "Passa al tema scuro",
    languageLabel: "Lingua",
    languageEnglish: "Inglese",
    languageHindi: "Hindi",
    heroEyebrow: "Età dell'auto, chiara",
    heroTitle: "Uno strumento pulito per l'età del veicolo.",
    heroDescription:
      "Seleziona l'anno di produzione. Aggiungi un mese solo se vuoi un risultato più preciso.",
    yearSelectLabel: "Anno di produzione",
    monthSelectLabel: "Mese di produzione",
    includeMonthLabel: "Includi un mese specifico per maggiore precisione",
    includeMonthNote:
      "Se non includi un mese, per il calcolo viene usato gennaio.",
    yearOnlyBadge: "Solo anno",
    yearMonthBadge: "Anno + mese",
    yearPlaceholder: "Seleziona anno",
    monthPlaceholder: "Seleziona mese",
    inputTitle: "Anno di produzione",
    inputLabel: "Anno di produzione",
    blockedDateNote: "Gli anni futuri sono bloccati.",
    result: "Risultato",
    vehicleAgeLead: "Il tuo veicolo è",
    asOfToday: "Ad oggi",
    years: "Anni",
    months: "Mesi",
    days: "Giorni",
    totalDays: (count) => `${count.toLocaleString("en-IN")} giorni totali`,
    ageLabels: {
      almostNew: "Quasi nuovo",
      modern: "Moderno",
      mature: "Maturo",
      classic: "Classico",
    },
    estimatedValue: {
      high: "Alto potenziale di rivendita",
      healthy: "Buona tenuta del valore",
      moderate: "Deprezzamento moderato",
      collector: "L'interesse dei collezionisti può crescere",
    },
    maintenanceTitle: "Manutenzione",
    maintenance: {
      routine: "Manutenzione ordinaria e cura OEM",
      watch: "Controlla freni, fluidi e pneumatici",
      plan: "Pianifica usura e controlli",
      specialized: "La manutenzione specializzata diventa importante",
    },
    registrationTitle: "Immatricolazione",
    registration: {
      collector: "In alcune regioni può valere un trattamento da collezione",
      classic: "In alcune regioni può applicarsi l'immatricolazione storica",
      standard: "Aspettati rinnovi standard e controlli regionali",
      regular: "Di solito si applica l'immatricolazione normale",
    },
    upcomingMilestoneTitle: "Prossima tappa",
    milestoneTimelineTitle: "Cronologia delle tappe",
    milestoneRemaining: ({ label, days }) => `${label} tra ${days.toLocaleString("it-IT")} giorni`,
    reached: "Raggiunta",
    upcoming: "Prossima",
    allMilestonesReachedTitle: "Tutte le tappe elencate sono state raggiunte",
    allMilestonesReachedBody:
      "Questo veicolo ha già superato l'intervallo di tappe mostrato nell'app.",
    copySummary: "Copia riepilogo",
    shareResult: "Condividi risultato",
    resetMessage: "Calcolatore reimpostato",
    summaryCopied: "Riepilogo copiato negli appunti",
    clipboardFailed: "Impossibile accedere agli appunti",
    emptyTitle: "Scegli un anno di produzione per vedere il dettaglio completo",
    emptyDescription:
      "Dopo aver scelto l'anno vedrai età esatta, giorni totali, note di manutenzione, stato classico e tappe.",
    shareTitle: "Calcolatore età veicolo",
    summary: ({ label, years, months, days, asOf }) =>
      `La mia auto è stata prodotta nel ${label} e al ${asOf} ha ${years} anni, ${months} mesi e ${days} giorni.`,
    milestones: {
      1: { label: "Primo anno", note: "Utile per garanzia e pianificazione dell'assistenza." },
      3: { label: "Tre anni", note: "Punto comune per rivendita e variazioni di valore." },
      5: { label: "Cinque anni", note: "Buon momento per rivedere il budget di manutenzione." },
      10: { label: "Dieci anni", note: "I componenti più vecchi meritano più attenzione." },
      15: { label: "Quindici anni", note: "In molte regioni qui inizia il trattamento storico." },
      25: { label: "Venticinque anni", note: "Può interessare collezionisti e mercati di importazione." },
    },
  };
